// Custom JavaScript for theme customizations
document.addEventListener('DOMContentLoaded', function() {
  // Placeholder to verify JS is loading
  console.debug('Custom JS loaded');
});


//==================================== TIMELINE SLIDER ==========x==========================

// GSAP Timeline Slider functionality
function initTimelineSlideShow(el) {
  
  // Save all elements in an object for easy reference
  const ui = {
    el,
    slides: Array.from(el.querySelectorAll('[data-slideshow="slide"]')),
    inner: Array.from(el.querySelectorAll('[data-slideshow="parallax"]')),
    thumbs: Array.from(el.querySelectorAll('[data-slideshow="thumb"]')),
    dots: Array.from(el.querySelectorAll('[data-slideshow="dot"]')),
    prevBtn: el.querySelector('[data-slideshow="prev"]'),
    nextBtn: el.querySelector('[data-slideshow="next"]')
  };

  // Check if required elements exist
  if (!ui.slides.length || !ui.dots.length) {
    console.warn('Timeline slider: Missing required elements');
    return;
  }

  let current = 0;
  const length = ui.slides.length;
  let animating = false;
  let observer;
  let animationDuration = 0.9; // Define the duration of your 'slide' here

  ui.slides.forEach((slide, index) => {
    slide.setAttribute('data-index', index);
  });
  ui.thumbs.forEach((thumb, index) => {
    thumb.setAttribute('data-index', index);
  });
  ui.dots.forEach((dot, index) => {
    dot.setAttribute('data-index', index);
  });

  ui.slides[current].classList.add('is--current');
  ui.thumbs[current].classList.add('is--current');
  ui.dots[current].classList.add('is--current');

  function navigate(direction, targetIndex = null) {
    if (animating) return;
    animating = true;
    if (observer) observer.disable();

    const previous = current;
    current =
      targetIndex !== null && targetIndex !== undefined
        ? targetIndex
        : direction === 1
          ? current < length - 1
            ? current + 1
            : 0
          : current > 0
            ? current - 1
            : length - 1;

    const currentSlide = ui.slides[previous];
    const currentInner = ui.inner[previous];
    const upcomingSlide = ui.slides[current];
    const upcomingInner = ui.inner[current];

    if (typeof gsap !== 'undefined') {
    gsap.timeline({
      defaults: {
        duration: animationDuration,
          ease: 'power2.inOut' // Using default ease instead of custom
      },
      onStart: function() {
        upcomingSlide.classList.add('is--current');
        ui.thumbs[previous].classList.remove('is--current');
        ui.thumbs[current].classList.add('is--current');
        ui.dots[previous].classList.remove('is--current');
        ui.dots[current].classList.add('is--current');
      },
      onComplete: function() {
        currentSlide.classList.remove('is--current');
        animating = false;
        // Re-enable observer after a short delay
          if (observer) {
        setTimeout(() => observer.enable(), animationDuration);
          }
      }
    })
      .to(currentSlide, { xPercent: -direction * 100 },0)
      .to(currentInner, { xPercent: direction * 50 }, 0)
      .fromTo(upcomingSlide, { xPercent: direction * 100 }, { xPercent: 0 }, 0)
      .fromTo(upcomingInner, { xPercent: -direction * 50 }, { xPercent: 0 }, 0);
    }
  }

  function onClick(event) {
    const targetIndex = parseInt(event.currentTarget.getAttribute('data-index'), 10);
    if (targetIndex === current || animating) return;
    const direction = targetIndex > current ? 1 : -1;
    navigate(direction, targetIndex);
  }
  
  ui.thumbs.forEach(thumb => {
    thumb.addEventListener('click', onClick);
  });
  
  ui.dots.forEach(dot => {
    dot.addEventListener('click', onClick);
  });
  
  if (ui.prevBtn) {
  ui.prevBtn.addEventListener('click', () => navigate(-1));
  }
  if (ui.nextBtn) {
  ui.nextBtn.addEventListener('click', () => navigate(1));
  }

  if (typeof gsap !== 'undefined' && gsap.Observer) {
    observer = gsap.Observer.create({
    target: el,
    type: 'wheel,touch,pointer',
    // Drag events to go left/right
    onLeft: () => { if (!animating) navigate(1); },
    onRight: () => {if (!animating) navigate(-1); },
    // For wheel events, check horizontal movement
    onWheel: (event) => {
      if (animating) return;
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        if (event.deltaX > 50) {
          navigate(1);
        } else if (event.deltaX < -50) {
          navigate(-1);
        }
      }
    },
    wheelSpeed: -1,
    tolerance: 10
  });
  }

  // Manual touch/swipe support as fallback (works even without GSAP Observer)
  let startX = 0;
  let startY = 0;
  let touchStartTime = 0;
  
  el.addEventListener('touchstart', (e) => {
    if (animating) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    touchStartTime = Date.now();
  }, { passive: true });
  
  el.addEventListener('touchend', (e) => {
    if (animating || !startX || !startY) return;
    
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const diffX = startX - endX;
    const diffY = startY - endY;
    const touchDuration = Date.now() - touchStartTime;
    
    // Only trigger if horizontal swipe is more significant than vertical
    // and swipe distance is sufficient (at least 50px)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        // Swipe left - next slide
        navigate(1);
      } else {
        // Swipe right - previous slide
        navigate(-1);
      }
    }
    
    startX = 0;
    startY = 0;
    touchStartTime = 0;
  }, { passive: true });

  // Cleanup function if you need it
  return {
    destroy: function() {
      if (observer) observer.kill();
      ui.thumbs.forEach(thumb => {
        thumb.removeEventListener('click', onClick);
      });
      ui.dots.forEach(dot => {
        dot.removeEventListener('click', onClick);
      });
      if (ui.prevBtn) {
      ui.prevBtn.removeEventListener('click', () => navigate(-1));
      }
      if (ui.nextBtn) {
      ui.nextBtn.removeEventListener('click', () => navigate(1));
      }
    }
  };
}

function initTimelineSliders() {
  let wrappers = document.querySelectorAll('[data-slideshow="wrap"]');
  wrappers.forEach(wrap => {
    // Skip review sliders - they use different initialization
    if (wrap.classList.contains('review-slider')) {
      return;
    }
    // Skip press sliders - they use initPressSliders with .press-slider__main-slide / nav-slide
    if (wrap.classList.contains('press-slider')) {
      return;
    }

    // Initialize when required parts are present (more resilient than relying on a specific class)
    const hasSlides = wrap.querySelectorAll('[data-slideshow="slide"]').length > 0;
    const hasDots = wrap.querySelectorAll('[data-slideshow="dot"]').length > 0;
    if (hasSlides && hasDots) {
      initTimelineSlideShow(wrap);
    } else {
      console.warn('Timeline slider skipped: missing slides or dots', { hasSlides, hasDots, wrap });
    }
  });
}



//==================================== REVIEWS SLIDER ==========x==========================

// GSAP Reviews Slider functionality
function initReviewSlideShow(el) {
  
  // Find the parent section to scope image slides
  const section = el.closest('.shopify-section') || el.closest('.custom-reviews-slider');
  
  // Save all elements in an object for easy reference
  const ui = {
    el,
    slides: Array.from(el.querySelectorAll('[data-slideshow="slide"]')),
    dots: Array.from(el.querySelectorAll('[data-slideshow="dot"]')),
    prevBtn: el.querySelector('[data-slideshow="prev"]'),
    nextBtn: el.querySelector('[data-slideshow="next"]'),
    // Find image slides in the same section (scoped to avoid conflicts)
    imageSlides: section ? Array.from(section.querySelectorAll('.review-image-slide')) : Array.from(document.querySelectorAll('.review-image-slide'))
  };

  // Check if required elements exist
  if (!ui.slides.length || !ui.dots.length) {
    console.warn('Review slider: Missing required elements');
    return;
  }

  let current = 0;
  const length = ui.slides.length;
  let animating = false;
  let observer;
  let animationDuration = 0.6; // Define the duration of your fade transition

  ui.slides.forEach((slide, index) => {
    slide.setAttribute('data-index', index);
  });
  ui.dots.forEach((dot, index) => {
    dot.setAttribute('data-index', index);
  });
  ui.imageSlides.forEach((imageSlide, index) => {
    imageSlide.setAttribute('data-index', index);
  });

  ui.slides[current].classList.add('is--current');
  ui.dots[current].classList.add('is--current');
  
  // Initialize image slides - set first one to current position, others off-screen
  if (ui.imageSlides.length > 0) {
    ui.imageSlides.forEach((imageSlide, index) => {
      if (index === current) {
        imageSlide.classList.add('is--current');
        if (typeof gsap !== 'undefined') {
          gsap.set(imageSlide, { xPercent: 0 });
        }
      } else {
        imageSlide.classList.remove('is--current');
        if (typeof gsap !== 'undefined') {
          gsap.set(imageSlide, { xPercent: 100 });
        }
      }
    });
  }

  function navigate(direction, targetIndex = null) {
    if (animating) return;
    animating = true;
    if (observer) observer.disable();

    const previous = current;
    current =
      targetIndex !== null && targetIndex !== undefined
        ? targetIndex
        : direction === 1
          ? current < length - 1
            ? current + 1
            : 0
          : current > 0
            ? current - 1
            : length - 1;

    const currentSlide = ui.slides[previous];
    const upcomingSlide = ui.slides[current];
    const currentImageSlide = ui.imageSlides[previous];
    const upcomingImageSlide = ui.imageSlides[current];

    if (typeof gsap !== 'undefined') {
      gsap.timeline({
        defaults: {
          duration: animationDuration / 3,
          ease: 'power2.inOut'
        },
        onStart: function() {
          ui.dots[previous].classList.remove('is--current');
          ui.dots[current].classList.add('is--current');
        },
        onComplete: function() {
          animating = false;
          // Re-enable observer after a short delay
          if (observer) {
            setTimeout(() => observer.enable(), animationDuration);
          }
        }
      })
        .to(currentSlide, { 
          opacity: 0,
          onComplete: function() {
            currentSlide.classList.remove('is--current');
            upcomingSlide.classList.add('is--current');
          }
        }, 0)
        .fromTo(upcomingSlide, { opacity: 0 }, { 
          opacity: 1 
        }, animationDuration / 3 * 2);
        
      // Sync image slides if they exist - using timeline slider approach
      if (currentImageSlide && upcomingImageSlide) {
        gsap.timeline({
          defaults: {
            duration: animationDuration,
            ease: 'power2.inOut'
          },
          onStart: function() {
            currentImageSlide.classList.remove('is--current');
            upcomingImageSlide.classList.add('is--current');
          }
        })
          .to(currentImageSlide, { xPercent: -100 }, 0)
          .fromTo(upcomingImageSlide, { xPercent: 100 }, { xPercent: 0 }, 0);
      }
    }
  }

  function onClick(event) {
    const targetIndex = parseInt(event.currentTarget.getAttribute('data-index'), 10);
    if (targetIndex === current || animating) return;
    const direction = targetIndex > current ? 1 : -1;
    navigate(direction, targetIndex);
  }
  
  ui.dots.forEach(dot => {
    dot.addEventListener('click', onClick);
  });
  
  if (ui.prevBtn) {
    ui.prevBtn.addEventListener('click', () => navigate(-1));
  }
  if (ui.nextBtn) {
    ui.nextBtn.addEventListener('click', () => navigate(1));
  }

  // Enable touch swipe, mouse drag, and wheel scrolling
  if (typeof gsap !== 'undefined' && gsap.Observer) {
    observer = gsap.Observer.create({
      target: el,
      type: 'wheel,touch,pointer',
      // Drag events to go left/right
      onLeft: () => { if (!animating) navigate(1); },
      onRight: () => {if (!animating) navigate(-1); },
      // For wheel events, check horizontal movement
      onWheel: (event) => {
        if (animating) return;
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          if (event.deltaX > 50) {
            navigate(1);
          } else if (event.deltaX < -50) {
            navigate(-1);
          }
        }
      },
      wheelSpeed: -1,
      tolerance: 10
    });
  }

  // Manual touch/swipe support as fallback (works even without GSAP Observer)
  let startX = 0;
  let startY = 0;
  let touchStartTime = 0;
  
  el.addEventListener('touchstart', (e) => {
    if (animating) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    touchStartTime = Date.now();
  }, { passive: true });
  
  el.addEventListener('touchend', (e) => {
    if (animating || !startX || !startY) return;
    
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const diffX = startX - endX;
    const diffY = startY - endY;
    const touchDuration = Date.now() - touchStartTime;
    
    // Only trigger if horizontal swipe is more significant than vertical
    // and swipe distance is sufficient (at least 50px)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        // Swipe left - next slide
        navigate(1);
      } else {
        // Swipe right - previous slide
        navigate(-1);
      }
    }
    
    startX = 0;
    startY = 0;
    touchStartTime = 0;
  }, { passive: true });

  // Cleanup function if you need it
  return {
    destroy: function() {
      if (observer) observer.kill();
      ui.dots.forEach(dot => {
        dot.removeEventListener('click', onClick);
      });
      if (ui.prevBtn) {
        ui.prevBtn.removeEventListener('click', () => navigate(-1));
      }
      if (ui.nextBtn) {
        ui.nextBtn.removeEventListener('click', () => navigate(1));
      }
    }
  };
}

function initReviewSliders() {
  let reviewSliders = document.querySelectorAll('.review-slider');
  reviewSliders.forEach(slider => {
    initReviewSlideShow(slider);
  });
}




//==================================== ICON ACCORDIONS ==========x==========================

function initAccordions() {
  const accordionBlocks = document.querySelectorAll('.accordion-block');
  
  accordionBlocks.forEach(block => {
    const accordionHead = block.querySelector('.icon-accordion-head');
    const accordionBody = block.querySelector('.icon-accordion-body');
    const plusIcon = block.querySelector('.custom-plus');
    
    if (accordionHead && accordionBody) {
      accordionHead.addEventListener('click', function() {
        const isActive = accordionBody.classList.contains('active');
        
        if (isActive) {
          accordionBody.classList.remove('active');
          if (plusIcon) plusIcon.classList.remove('active-plus');
        } else {
          accordionBody.classList.add('active');
          if (plusIcon) plusIcon.classList.add('active-plus');
        }
      });
    }
  });
}



//==================================== PRESS SLIDER ====================================

function initPressSlideShow(el) {
  // Find main slider and nav slider within .press-slider
  const mainSlider = el.querySelector('.press-slider__main');
  const navSlider = el.querySelector('.press-slider__nav');
  const mainSlides = Array.from(el.querySelectorAll('.press-slider__main-slide'));
  const navSlides = Array.from(el.querySelectorAll('.press-slider__nav-slide'));
  const prevBtn = el.querySelector('[data-slideshow="prev"]');
  const nextBtn = el.querySelector('[data-slideshow="next"]');
  
  if (!mainSlider || !navSlider || !mainSlides.length || !navSlides.length) {
    console.warn('Press slider: Missing required elements');
    return;
  }
  
  let currentIndex = 0;
  let animating = false;
  const animationDuration = 0.6;
  const autoplayEnabled = el.getAttribute('data-autoplay') === 'true';
  
  // Initialize main slides for fade effect
  mainSlides.forEach((slide, index) => {
    slide.style.opacity = index === 0 ? '1' : '0';
    slide.style.position = 'absolute';
    slide.style.top = '0';
    slide.style.left = '0';
    slide.style.width = '100%';
    slide.style.transition = 'opacity 0.6s ease-in-out';
  });
  
  // Initialize nav slides
  navSlides.forEach((slide, index) => {
    slide.classList.toggle('active', index === 0);
    slide.addEventListener('click', () => goToSlide(index));
  });
  
  function goToSlide(index) {
    if (animating || index === currentIndex) return;
    
    animating = true;
    const currentSlide = mainSlides[currentIndex];
    const nextSlide = mainSlides[index];
    
    if (typeof gsap !== 'undefined') {
      gsap.timeline({
        defaults: {
          duration: animationDuration / 3,
          ease: 'power2.inOut'
        },
        onStart: function() {
          navSlides[currentIndex].classList.remove('active');
          navSlides[index].classList.add('active');
        },
        onComplete: function() {
          animating = false;
          currentIndex = index;
        }
      })
        .to(currentSlide, { 
          opacity: 0,
          onComplete: function() {
            currentSlide.classList.remove('active');
            nextSlide.classList.add('active');
          }
        }, 0)
        .fromTo(nextSlide, { opacity: 0 }, { 
          opacity: 1 
        }, animationDuration / 3 * 2);
    } else {
      // Fallback without GSAP
      navSlides[currentIndex].classList.remove('active');
      navSlides[index].classList.add('active');
      currentSlide.style.opacity = '0';
      currentSlide.classList.remove('active');
      nextSlide.classList.add('active');
      nextSlide.style.opacity = '1';
      setTimeout(() => {
        animating = false;
        currentIndex = index;
      }, animationDuration * 1000);
    }
  }
  
  function goToNext() {
    const nextIndex = (currentIndex + 1) % mainSlides.length;
    goToSlide(nextIndex);
  }
  
  function goToPrev() {
    const prevIndex = currentIndex === 0 ? mainSlides.length - 1 : currentIndex - 1;
    goToSlide(prevIndex);
  }
  
  // Add event listeners for arrow buttons
  if (prevBtn) {
    prevBtn.addEventListener('click', goToPrev);
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', goToNext);
  }
  
  // Auto-play functionality
  let autoPlayInterval;
  function startAutoPlay() {
    autoPlayInterval = setInterval(() => {
      goToNext();
    }, 5000);
  }
  
  function stopAutoPlay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
    }
  }
  
  // Start auto-play only if enabled
  if (autoplayEnabled) {
    startAutoPlay();
  }
  
  // Pause on hover (only if autoplay is enabled)
  if (autoplayEnabled) {
    el.addEventListener('mouseenter', stopAutoPlay);
    el.addEventListener('mouseleave', startAutoPlay);
  }
  
  // Touch/swipe support
  let startX = 0;
  let startY = 0;
  
  el.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  });
  
  el.addEventListener('touchend', (e) => {
    if (!startX || !startY) return;
    
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;
    const diffX = startX - endX;
    const diffY = startY - endY;
    
    // Only trigger if horizontal swipe is more significant than vertical
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        // Swipe left - next slide
        goToNext();
      } else {
        // Swipe right - previous slide
        goToPrev();
      }
    }
    
    startX = 0;
    startY = 0;
  });
  
  // Cleanup function
  return {
    destroy: function() {
      stopAutoPlay();
      navSlides.forEach(slide => {
        slide.removeEventListener('click', () => goToSlide);
      });
      if (prevBtn) {
        prevBtn.removeEventListener('click', goToPrev);
      }
      if (nextBtn) {
        nextBtn.removeEventListener('click', goToNext);
      }
    }
  };
}

function initPressSliders() {
  let pressSliders = document.querySelectorAll('.press-slider');
  pressSliders.forEach(slider => {
    initPressSlideShow(slider);
  });
}





// Register GSAP plugins if available
if (typeof gsap !== 'undefined') {
  // Check for Observer (might be global or on gsap)
  if (typeof Observer !== 'undefined') {
    gsap.registerPlugin(Observer);
  } else if (gsap.Observer) {
    gsap.registerPlugin(gsap.Observer);
  }
  
  // Check for Draggable (might be global or on gsap)
  if (typeof Draggable !== 'undefined') {
    gsap.registerPlugin(Draggable);
  } else if (gsap.Draggable) {
    gsap.registerPlugin(gsap.Draggable);
  }
  
  // Check for InertiaPlugin (might be global or on gsap)
  if (typeof InertiaPlugin !== 'undefined') {
    gsap.registerPlugin(InertiaPlugin);
  } else if (gsap.InertiaPlugin) {
    gsap.registerPlugin(gsap.InertiaPlugin);
  }
}

//==================================== NUTRITIONAL SLIDER ==========x==========================
function initNutritionalSlider() {
  // Check if GSAP and required plugins are available
  if (typeof gsap === 'undefined' || (typeof Draggable === 'undefined' && !gsap.Draggable)) {
    console.warn('GSAP or Draggable plugin not available for nutritional slider');
    return;
  }

  document.querySelectorAll('.nutritional-slider__collection').forEach(root => {
    if (root._sliderDraggable) root._sliderDraggable.kill();

    const collection = root; // root is already the collection
    const track      = root.querySelector('[data-gsap-slider-list]');
    const items      = Array.from(root.querySelectorAll('[data-gsap-slider-item]'));
    const controls   = Array.from(root.parentElement.querySelectorAll('[data-gsap-slider-control]'));

    // Inject aria attributes
    root.setAttribute('role','region');
    root.setAttribute('aria-roledescription','carousel');
    root.setAttribute('aria-label','Slider');
    collection.setAttribute('role','group');
    collection.setAttribute('aria-roledescription','Slides List');
    collection.setAttribute('aria-label','Slides');
    items.forEach((slide,i) => {
      slide.setAttribute('role','group');
      slide.setAttribute('aria-roledescription','Slide');
      slide.setAttribute('aria-label',`Slide ${i+1} of ${items.length}`);
      slide.setAttribute('aria-hidden','true');
      slide.setAttribute('aria-selected','false');
      slide.setAttribute('tabindex','-1');
    });
    controls.forEach(btn => {
      const dir = btn.getAttribute('data-gsap-slider-control');
      btn.setAttribute('role','button');
      btn.setAttribute('aria-label', dir==='prev' ? 'Previous Slide' : 'Next Slide');
      btn.disabled = true;
      btn.setAttribute('aria-disabled','true');
    });

    // Determine if slider runs
    const styles      = getComputedStyle(root);
    const statusVar   = styles.getPropertyValue('--slider-status').trim();
    let   spvVar      = parseFloat(styles.getPropertyValue('--slider-spv'));
    const rect        = items[0].getBoundingClientRect();
    const marginRight = parseFloat(getComputedStyle(items[0]).marginRight);
    const slideW      = rect.width + marginRight;
    if (isNaN(spvVar)) {
      spvVar = collection.clientWidth / slideW;
    }
    const spv           = Math.max(1, Math.min(spvVar, items.length));
    const sliderEnabled = statusVar==='on' && spv < items.length;
    root.setAttribute('data-gsap-slider-status', sliderEnabled ? 'active' : 'not-active');

    if (!sliderEnabled) {
      // Teardown when disabled
      track.removeAttribute('style');
      track.onmouseenter = null;
      track.onmouseleave = null;
      track.removeAttribute('data-gsap-slider-list-status');
      root.removeAttribute('role');
      root.removeAttribute('aria-roledescription');
      root.removeAttribute('aria-label');
      collection.removeAttribute('role');
      collection.removeAttribute('aria-roledescription');
      collection.removeAttribute('aria-label');
      items.forEach(slide => {
        slide.removeAttribute('role');
        slide.removeAttribute('aria-roledescription');
        slide.removeAttribute('aria-label');
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('aria-selected');
        slide.removeAttribute('tabindex');
        slide.removeAttribute('data-gsap-slider-item-status');
      });
      controls.forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('role');
        btn.removeAttribute('aria-label');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-gsap-slider-control-status');
      });
      return;
    }

    // Track hover state
    track.onmouseenter = () => {
      track.setAttribute('data-gsap-slider-list-status','grab');
    };
    track.onmouseleave = () => {
      track.removeAttribute('data-gsap-slider-list-status');
    };

    //Ccalculate bounds and snap points
    const vw        = collection.clientWidth;
    const tw        = track.scrollWidth;
    const maxScroll = Math.max(tw - vw, 0);
    const minX      = -maxScroll;
    const maxX      = 0;
    const maxIndex  = maxScroll / slideW;
    const full      = Math.floor(maxIndex);
    const snapPoints = [];
    for (let i = 0; i <= full; i++) {
      snapPoints.push(-i * slideW);
    }
    if (full < maxIndex) {
      snapPoints.push(-maxIndex * slideW);
    }

    let activeIndex    = 0;
    const setX         = gsap.quickSetter(track,'x','px');
    let collectionRect = collection.getBoundingClientRect();

    function updateStatus(x) {
      if (x > maxX || x < minX) {
        return;
      }

      // Clamp and find closest snap
      const calcX = x > maxX ? maxX : (x < minX ? minX : x);
      let closest = snapPoints[0];
      snapPoints.forEach(pt => {
        if (Math.abs(pt - calcX) < Math.abs(closest - calcX)) {
          closest = pt;
        }
      });
      activeIndex = snapPoints.indexOf(closest);

      // Update Slide Attributes
      items.forEach((slide,i) => {
        const r           = slide.getBoundingClientRect();
        const leftEdge    = r.left - collectionRect.left;
        const slideCenter = leftEdge + r.width/2;
        const inView      = slideCenter > 0 && slideCenter < collectionRect.width;
        const status      = i === activeIndex ? 'active' : inView ? 'inview' : 'not-active';

        slide.setAttribute('data-gsap-slider-item-status', status);
        slide.setAttribute('aria-selected',    i === activeIndex ? 'true' : 'false');
        slide.setAttribute('aria-hidden',      inView ? 'false' : 'true');
        slide.setAttribute('tabindex',         i === activeIndex ? '0'    : '-1');
      });

      // Update Controls
      controls.forEach(btn => {
        const dir = btn.getAttribute('data-gsap-slider-control');
        const can = dir === 'prev'
          ? activeIndex > 0
          : activeIndex < snapPoints.length - 1;

        btn.disabled = !can;
        btn.setAttribute('aria-disabled', can ? 'false' : 'true');
        btn.setAttribute('data-gsap-slider-control-status', can ? 'active' : 'not-active');
      });
    }

    controls.forEach(btn => {
      const dir = btn.getAttribute('data-gsap-slider-control');
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const delta = dir === 'next' ? 1 : -1;
        const target = activeIndex + delta;
        gsap.to(track, {
          duration: 0.4,
          x: snapPoints[target],
          onUpdate: () => updateStatus(gsap.getProperty(track,'x'))
        });
      });
    });

    // Initialize Draggable with InertiaPlugin
    const DraggableRef = typeof Draggable !== 'undefined' ? Draggable : gsap.Draggable;
    root._sliderDraggable = DraggableRef.create(track, {
      type: 'x',
      inertia: true,
      bounds: {minX, maxX},
      throwResistance: 1000, // Higher = more momentum with InertiaPlugin
      dragResistance: 0.02,  // Slightly higher for better control
      maxDuration: 2.0,     // Longer duration for smooth momentum
      minDuration: 0.1,     // Minimum duration for quick flicks
      edgeResistance: 0.5,   // Some resistance at edges
      snap: {x: snapPoints, duration: 0.3}, // Smooth snap
      onPress() {
        track.setAttribute('data-gsap-slider-list-status','grabbing');
        collectionRect = collection.getBoundingClientRect();
      },
      onDrag() {
        setX(this.x);
        updateStatus(this.x);
      },
      onThrowUpdate() {
        setX(this.x);
        updateStatus(this.x);
      },
      onThrowComplete() {
        setX(this.endX);
        updateStatus(this.endX);
        track.setAttribute('data-gsap-slider-list-status','grab');
      },
      onRelease() {
        setX(this.x);
        updateStatus(this.x);
        track.setAttribute('data-gsap-slider-list-status','grab');
      }
    })[0];

    // Initial state
    setX(0);
    updateStatus(0);
  });
}

// Debouncer: For resizing the window
function debounceOnWidthChange(fn, ms) {
  let last = innerWidth, timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (innerWidth !== last) {
        last = innerWidth;
        fn.apply(this, args);
      }
    }, ms);
  };
}

window.addEventListener('resize', debounceOnWidthChange(initNutritionalSlider, 200));



// Initialize all functionality
document.addEventListener('DOMContentLoaded', () => {
  initAccordions();
  initTimelineSliders();
  initReviewSliders();
  initPressSliders();
  initNutritionalSlider();
});

//==================================== AUTO-SELECT SUBSCRIPTION WHEN VARIANT HAS SUBSCRIPTION OPTION ==========x==========================

/**
 * When the selected variant has a subscription option, auto-select the "Subscribe & save"
 * radio in the subscription widget. Works on page load and when switching variants.
 */
(function() {
  function selectSubscriptionRadioForVariant(variantId) {
    if (!variantId) return false;
    const variantIdStr = String(variantId);

    // Find the visible subscription section for this variant (not hidden)
    const section = document.querySelector(
      '.shopify_subscriptions_app_block[data-variant-id="' + variantIdStr + '"]:not(.shopify_subscriptions_app_block--hidden), ' +
      '.shopify_subscriptions_app_container [data-variant-id="' + variantIdStr + '"]:not(.shopify_subscriptions_app_block--hidden)'
    );
    if (!section) return false;

    // Find the "Subscribe & save" radio (selling_plan) - variant has subscription if this exists
    const subscriptionRadio = section.querySelector('input[data-radio-type="selling_plan"]');
    if (!subscriptionRadio) return false;

    if (subscriptionRadio.checked) return true;

    // Select the subscription option
    subscriptionRadio.checked = true;
    subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));

    // Update hidden selling_plan inputs (subscription block + product form)
    const planId = subscriptionRadio.dataset.sellingPlanId;
    if (planId) {
      document.querySelectorAll('input.selected-selling-plan-id, input[name="selling_plan"]').forEach(function(inp) {
        if (inp.value !== planId) {
          inp.value = planId;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    return true;
  }

  function attemptSubscriptionSelection(variantId) {
    if (!variantId) {
      const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
      if (!picker) return;
      const script = picker.querySelector('script[type="application/json"]');
      if (!script) return;
      try {
        const v = JSON.parse(script.textContent);
        variantId = v?.id;
      } catch (e) { return; }
    }
    selectSubscriptionRadioForVariant(variantId);
  }

  function runWithRetry(getVariantId, attempts = 5, delay = 300) {
    let n = 0;
    function tryRun() {
      const vid = getVariantId();
      if (vid && selectSubscriptionRadioForVariant(vid)) return;
      if (++n < attempts) setTimeout(tryRun, delay);
    }
    setTimeout(tryRun, 100);
  }

  // On page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      runWithRetry(() => {
        const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
        const script = picker?.querySelector('script[type="application/json"]');
        try {
          return script ? JSON.parse(script.textContent)?.id : null;
        } catch (e) { return null; }
      });
    });
  } else {
    runWithRetry(() => {
      const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
      const script = picker?.querySelector('script[type="application/json"]');
      try {
        return script ? JSON.parse(script.textContent)?.id : null;
      } catch (e) { return null; }
    });
  }

  // On variant change - run after sync has shown the correct section
  document.addEventListener('variant:update', function(event) {
    const variantId = event.detail?.resource?.id;
    setTimeout(() => attemptSubscriptionSelection(variantId), 150);
  });
})();

//==================================== UPDATE VARIANT SUBSCRIPTION DETAILS ON VARIANT CHANGE ==========x==========================

/**
 * Show/hide variant subscription details based on selected variant
 */
(function() {
  function updateSubscriptionDetails(event) {
    const variant = event.detail?.resource;
    if (!variant || !variant.id) {
      return;
    }

    const variantId = String(variant.id);
    const allDetails = document.querySelectorAll('.variant-subscription-details');
    
    allDetails.forEach(detail => {
      if (detail.getAttribute('data-variant-id') === variantId) {
        detail.style.display = '';
      } else {
        detail.style.display = 'none';
      }
    });
  }

  // Initialize on page load
  function initSubscriptionDetails() {
    const variantPicker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!variantPicker) return false;

    const variantScript = variantPicker.querySelector('script[type="application/json"]');
    if (!variantScript) return false;

    try {
      const variant = JSON.parse(variantScript.textContent);
      if (variant && variant.id) {
        updateSubscriptionDetails({ detail: { resource: variant } });
        return true;
      }
    } catch (e) {
      console.error('[Subscription Details] Error:', e);
    }
    return false;
  }

  // Listen for variant updates
  document.addEventListener('variant:update', updateSubscriptionDetails);

  // Initialize on page load with retry for async content
  function runDetailsInit() {
    let n = 0;
    function tryInit() {
      if (initSubscriptionDetails() || ++n >= 5) return;
      setTimeout(tryInit, 200);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(tryInit, 100));
    } else {
      setTimeout(tryInit, 100);
    }
  }
  runDetailsInit();
})();

//==================================== KEEP SUBSCRIPTION APP BLOCK IN SYNC WITH VARIANT ==========x==========================

/**
 * Some subscription app-embed blocks render one block of markup per variant:
 *
 * <div class="shopify_subscriptions_app_block_container">
 *   <section data-variant-id="..."> ... </section>
 *   <section data-variant-id="..."> ... </section>
 *   ...
 * </div>
 *
 * The app's own script is responsible for toggling visibility between these,
 * but in some cases it can fail with null-reference errors and stop updating
 * when variants change. To keep the UX stable, we listen for the same
 * variant:update events the rest of the theme uses and ensure the correct
 * section is shown by adding/removing the "shopify_subscriptions_app_block--hidden"
 * class. This does not change purchase type (one-time vs subscription); it
 * only keeps the visible block in sync with the selected variant.
 */
(function() {
  function getVariantIdFromEvent(event) {
    const detail = event.detail || {};
    const resource = detail.resource || detail.variant || detail.data?.variant || detail.data?.newProduct;
    if (!resource || !resource.id) return null;
    return String(resource.id);
  }

  // Fallback: derive current variant id directly from the main variant picker DOM
  function getCurrentVariantIdFromDom(picker) {
    const p = picker || document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!p) return null;

    // Radio-style: get the last selected option with variant-id (for multi-option products)
    const checkedRadios = p.querySelectorAll('input[type="radio"][data-variant-id]:checked');
    if (checkedRadios.length) {
      const last = checkedRadios[checkedRadios.length - 1];
      if (last.dataset.variantId) return String(last.dataset.variantId);
    }

    // Dropdown-style: get selected option with variant-id from each select
    const selects = p.querySelectorAll('select');
    for (let i = selects.length - 1; i >= 0; i--) {
      const opt = selects[i].options[selects[i].selectedIndex];
      if (opt?.dataset?.variantId) return String(opt.dataset.variantId);
    }

    // As a last resort, try the JSON script inside the picker
    const variantScript = p.querySelector('script[type="application/json"]');
    if (variantScript) {
      try {
        const variant = JSON.parse(variantScript.textContent);
        if (variant && variant.id) return String(variant.id);
      } catch (e) {
        console.error('[Subscription App Block Sync] Error parsing variant JSON from DOM:', e);
      }
    }

    return null;
  }

  function syncSubscriptionBlocksToVariant(variantId, root = document) {
    if (!variantId) return;

    // Primary: subscription app block container (Shopify uses shopify_subscriptions_app_container)
    const containers = root.querySelectorAll('.shopify_subscriptions_app_block_container, .shopify_subscriptions_app_container');
    containers.forEach(container => {
      const sections = container.querySelectorAll('.shopify_subscriptions_app_block, [data-variant-id]');
      sections.forEach(section => {
        const sectionVariantId = section.getAttribute('data-variant-id');
        if (!sectionVariantId) return;
        const isActive = sectionVariantId === variantId;
        section.classList.toggle('shopify_subscriptions_app_block--hidden', !isActive);
        section.style.display = isActive ? '' : 'none';
      });
    });

    // Fallback: variant-specific blocks inside shopify-app-block (e.g. different app structures)
    root.querySelectorAll('.shopify-app-block [data-variant-id]').forEach(el => {
      const sectionVariantId = el.getAttribute('data-variant-id');
      if (!sectionVariantId) return;
      const isActive = sectionVariantId === variantId;
      el.classList.toggle('shopify_subscriptions_app_block--hidden', !isActive);
      el.style.display = isActive ? '' : 'none';
    });
  }

  function handleVariantUpdate(event) {
    const variantId = getVariantIdFromEvent(event);
    if (!variantId) return;
    syncSubscriptionBlocksToVariant(variantId);
  }

  // Also sync whenever the main product variant picker changes. Dispatch a synthetic
  // variant:update immediately so subscription sync runs without waiting for fetch.
  function handleVariantPickerChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const picker = target.closest('variant-picker');
    if (!picker || picker.dataset.templateProductMatch !== 'true') return;

    // Use requestAnimationFrame so DOM has updated (e.g. selected option) before we read
    requestAnimationFrame(() => {
      const variantId = getCurrentVariantIdFromDom(picker);
      if (!variantId) return;
      syncSubscriptionBlocksToVariant(variantId);
      // Dispatch synthetic variant:update so subscription details and other listeners run
      document.dispatchEvent(new CustomEvent('variant:update', {
        bubbles: true,
        detail: { resource: { id: variantId } }
      }));
    });
  }


  // Listen for variant events
  document.addEventListener('variant:update', handleVariantUpdate);

  document.addEventListener('change', handleVariantPickerChange, true);

  // Initial sync on page load. Retry a few times for async-loaded content (e.g. view transitions)
  function initSubscriptionBlocksSync() {
    const variantId = getCurrentVariantIdFromDom();
    if (!variantId) return;
    syncSubscriptionBlocksToVariant(variantId);
    // Dispatch so subscription details and other listeners also init
    document.dispatchEvent(new CustomEvent('variant:update', {
      bubbles: true,
      detail: { resource: { id: variantId } }
    }));
  }

  function runInitWithRetry(attempts = 5, delay = 200) {
    let n = 0;
    function tryInit() {
      initSubscriptionBlocksSync();
      if (++n < attempts) setTimeout(tryInit, delay);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(tryInit, 100));
    } else {
      setTimeout(tryInit, 100);
    }
  }

  runInitWithRetry();

  // Re-run when main content is replaced (e.g. view transitions / SPA navigation)
  const main = document.querySelector('main');
  if (main && typeof MutationObserver !== 'undefined') {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (document.querySelector('variant-picker[data-template-product-match="true"]')) {
          initSubscriptionBlocksSync();
        }
      }, 150);
    });
    observer.observe(main, { childList: true, subtree: true });
  }
})();

//==================================== APP EMBED BLOCK ERROR HANDLING ==========x==========================

/**
 * Handle errors from app-embed-block.js to prevent page breakage
 * The app embed block (likely for subscriptions/selling plans) may try to query
 * elements that don't exist, causing null reference errors
 */
(function() {
  // Catch and handle errors from app embed blocks
  window.addEventListener('error', function(event) {
    // Check if error is from app-embed-block.js
    if (event.filename && event.filename.includes('app-embed-block.js')) {
      // Check if it's the specific querySelector null error
      if (event.message && (
        event.message.includes('querySelector') || 
        event.message.includes('Cannot read properties of null')
      )) {
        console.warn('App embed block error caught and handled:', event.message);
        // Try to prevent the error from breaking the page
        event.preventDefault();
        event.stopPropagation();
        return true; // Return true to indicate error was handled
      }
    }
  }, true); // Use capture phase to catch errors early
  
  // Also add a try-catch wrapper for the window.onerror handler
  const originalOnError = window.onerror;
  window.onerror = function(msg, url, lineNo, columnNo, error) {
    // Check if error is from app-embed-block.js
    if (url && url.includes('app-embed-block.js')) {
      if (msg && (
        msg.includes('querySelector') || 
        msg.includes('Cannot read properties of null')
      )) {
        console.warn('App embed block error caught via window.onerror:', msg);
        return true; // Suppress the error
      }
    }
    // Call original handler if it exists
    if (originalOnError) {
      return originalOnError.call(this, msg, url, lineNo, columnNo, error);
    }
    return false;
  };

  // Also handle unhandled promise rejections that might come from app embed blocks
  window.addEventListener('unhandledrejection', function(event) {
    const reason = event.reason;
    const reasonStr = typeof reason === 'string' ? reason : (reason?.message || String(reason));
    if (reasonStr && (
      reasonStr.includes('querySelector') || 
      reasonStr.includes('Cannot read properties of null')
    )) {
      console.warn('App embed block promise rejection caught:', reasonStr);
      event.preventDefault();
    }
  });

  // Ensure required DOM elements exist before app embed blocks try to access them
  // This runs after DOM is ready and also after variant updates
  function ensureProductElementsExist() {
    const productForm = document.querySelector('product-form-component');
    const productFormTag = document.querySelector('form[data-type="add-to-cart-form"]');
    const productPrice = document.querySelector('product-price');
    const priceContainer = productPrice?.querySelector('[ref="priceContainer"]');
    
    // Ensure price element exists - app embed blocks often need this
    if (!productPrice && document.querySelector('.shopify-section')) {
      console.debug('Product price element not found, app embed blocks may encounter issues');
    }
    
    // Ensure price container exists
    if (productPrice && !priceContainer) {
      console.debug('Product price container not found');
    }
    
    // If product form component exists but form is missing, it might cause issues
    if (productForm && !productFormTag) {
      console.debug('Product form component found but form element missing');
    }
  }

  // Check on DOM ready
  function initCheck() {
    ensureProductElementsExist();
    
    // Wait a bit for app embed blocks to load
    setTimeout(ensureProductElementsExist, 100);
    setTimeout(ensureProductElementsExist, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheck);
  } else {
    initCheck();
  }

  // Also check after variant updates (app embed blocks often listen to these)
  document.addEventListener('variant:update', ensureProductElementsExist);
  document.addEventListener('variant:selected', ensureProductElementsExist);
  
  // Listen for variant update events on sections (as app embed blocks might be in sections)
  document.querySelectorAll('.shopify-section').forEach(section => {
    section.addEventListener('variant:update', ensureProductElementsExist);
  });

  // Use MutationObserver to watch for app embed blocks being added to DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if app embed block was added
          if (node.classList && node.classList.contains('app-embed-block') ||
              node.querySelector && node.querySelector('.app-embed-block')) {
            // Give it a moment to initialize, then check elements
            setTimeout(ensureProductElementsExist, 100);
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
